import { api } from "./api";

export const retPurchasesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRetPurchases: builder.query({
      query: () => "api/Purch/RetPurch",
      providesTags: ["retPurchases"],
    }),
    getRetPurchasesByDoc: builder.query({
      query: (docID) => `api/Purch/RetPurch?DocNumver=${docID}`,
      providesTags: ["retPurchases"],
    }),
    addRetPurchases: builder.mutation({
      query: (formData) => ({
        url: "api/Purch/RetPurch",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["retPurchases"],
    }),
    editRetPurchases: builder.mutation({
      query: (formData) => ({
        url: "api/Purch/RetPurch",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["retPurchases"],
    }),
    deleteRetPurchases: builder.mutation({
      query: (docID) => ({
        url: `api/Purch/RetPurch?DocID=${docID}`,
        method: "DELETE",
      }),
      invalidatesTags: ["retPurchases"],
    }),
  }),
});

export const {
  useGetRetPurchasesQuery,
  useLazyGetRetPurchasesByDocQuery,
  useAddRetPurchasesMutation,
  useEditRetPurchasesMutation,
  useDeleteRetPurchasesMutation,
} = retPurchasesApi;
